var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconlyChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.018 1.66602C5.1763 1.66602 1.66797 5.61602 1.66797 9.99935C1.66797 11.3994 2.0763 12.841 2.79297 14.1577C2.9263 14.3744 2.94297 14.6494 2.8513 14.9077L2.29297 16.7744C2.16797 17.2243 2.5513 17.5577 2.9763 17.4244L4.65963 16.9244C5.11797 16.7744 5.4763 16.966 5.90213 17.2244C7.1188 17.941 8.63463 18.3077 10.0013 18.3077C14.1346 18.3077 18.3346 15.116 18.3346 9.97435C18.3346 5.54102 14.7513 1.66602 10.018 1.66602Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14284 8.94151C6.73451 8.94151 7.20951 9.41651 7.20951 10.0082C7.20951 10.5915 6.73451 11.0665 6.14284 11.0748C5.55951 11.0748 5.07617 10.5915 5.07617 10.0082C5.07617 9.41651 5.55117 8.94151 6.14284 8.94151ZM9.98484 8.94151C10.5765 8.94151 11.0515 9.41651 11.0515 10.0082C11.0515 10.5915 10.5765 11.0748 9.98484 11.0748C9.39317 11.0665 8.91817 10.5915 8.91817 9.99985C8.91817 9.41651 9.4015 8.93318 9.98484 8.94151ZM13.8263 8.94151C14.418 8.94151 14.893 9.41651 14.893 10.0082C14.893 10.5915 14.418 11.0748 13.8263 11.0748C13.2347 11.0748 12.7597 10.5915 12.7597 10.0082C12.7597 9.41651 13.2347 8.94151 13.8263 8.94151Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyChat);
export default __webpack_public_path__ + "static/media/iconly_chat.e94afc2c7d67146ad165f906976fed19.svg";
export { ForwardRef as ReactComponent };